import { EditorStatus } from "components/EditorStatus/EditorStatus";
import { EditorTitle } from "components/EditorTitle/EditorTitle";
import { useContainer } from "features/container/Feature";
import { useCapabilities } from "hooks/pitcher/useCapabilities";
import { usePermissions } from "hooks/pitcher/usePermissions";
import { Box, Stack } from "prism-react";
import { useEditorServiceWorker } from "registerEditorServiceWorker";

import { MainMenu } from "./MainMenu";
import { VMResourcesStatusBadge } from "./VMResourcesStatusBadge";

export const Topbar: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const pitcherCapabilities = useCapabilities();
  const pitcherPermissions = usePermissions();
  const [container] = useContainer();
  const isInteractive = container.state === "READY";

  const canViewMetrics = !!(
    pitcherCapabilities.system?.metrics && pitcherPermissions.system?.metrics
  );

  // We register the service worker after everything is loaded up. This ensures that there is not a ton of file
  // fetching happening for the precache during opening the editor
  useEditorServiceWorker();

  return (
    <Box
      css={{
        paddingTop: "6px", // Custom alignment
        paddingRight: "$2",
        paddingLeft: "$2",
        height: "100%",
        background: "var(--vscode-activityBar-background, $neutral-bg-base)",
        borderBottom: "1px solid var(--vscode-titleBar-border)",
      }}
    >
      <Stack
        css={{
          justifyContent: "space-between",
          height: "100%",
          alignItems: "flex-start",
        }}
        gap={0}
        horizontal
      >
        <Stack
          css={{
            justifyContent: "flex-start",
            flex: 1,
          }}
          gap={3}
          horizontal
        >
          <MainMenu />
          <EditorStatus />
          {canViewMetrics && <VMResourcesStatusBadge />}
        </Stack>

        <EditorTitle isInteractive={isInteractive} />

        <Stack
          css={{
            justifyContent: "flex-end",
            flex: 1,
            height: "$8",
          }}
          gap={2}
          horizontal
        >
          {children}
        </Stack>
      </Stack>
    </Box>
  );
};
